import * as React from 'react'
import * as Assets from '../../../assets/Assets'
import * as Body from './Body'
import { Link } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import * as Utils from '../../../Logic/Utils'
import {Helmet} from 'react-helmet'

function getAboutHelp(content: string, menu: Assets.Menu[]): JSX.Element {
    let elements: JSX.Element[] = []
    for (let i = 0; i < menu.length; i++) {
        elements.push(
            <li key={i.toString()}>
                <Link to={menu[i].content.toLowerCase().replace(/\s/g, '')}>{menu[i].content}</Link>
            </li>
        )
    }

    return (<div className="col-lg-4 col-xs-4 footer-ul footer-mobile">
        <ul className="list-unstyled">
            <li><h3 className="heading">{content}</h3></li>
            {elements}
        </ul>
    </div>)
}

export class Footer extends React.Component {

    render() {
        return (
            /*Footer Start*/
            <footer className="footer">
                <div className="container-home">
                    <div className="row">
                        <div className="col-lg-6 col-sm-9" style={{ height: '100px' }}>
                            <div className="row">
                                {getAboutHelp('ABOUT', Assets.About)}
                                {getAboutHelp('HELP', Assets.Help)}
                                <div className="col-lg-4 col-xs-4 footer-ul footer-mobile">
                                    <div className="col-lg-12 col-sm-12 ">
                                        <ul className="social-icons clearfix">
                                            <li><a href="https://www.facebook.com/accumulatorclub/" target="_blank" className="fb"><i className="icon-facebook" /></a></li>
                                            <li><a href="https://twitter.com/theaccaclub" target="_blank" className="tw"><i className="icon-twitter" /></a></li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-12 col-sm-12 ">
                                        <img className="img-18" src="18+.svg"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-9">
                            <p className="footer-text">
                                All games offered on The Accumulator Club are free to play, with cash prizes. The Accumulator Club does not offer gambling facilities, although we may link to third party sites that do. Use of any third party website is at your own risk and we will not be liable for any losses or damages. For more information, please consult our terms of service and privacy policy.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="sub-footer">
                    <div className="container-home container-home-footer">
                        <div>
                            <p>&copy;{' ' + Assets.productYear + ' ' + Assets.productOwner + '. All Rights Reserved.'}</p>
                        </div>
                        <div className="powered-by-gamanza">
                            <img src={Assets.poweredByGamanzaWhite}/>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export class Contact extends React.Component<{}, { userDropdown: boolean, mobileMenu: boolean }> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            mobileMenu: false
        }
    }

    render() {
        return (
            <section className="wrapper">
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>The Accumulator Club – Social betting – Contact</title>
                    <meta 
                        name="description" 
                        content="The Accumulator Club is owned by Fair Play Gaming Ltd and powered by Gamanza
                        Group. We develop unique free to play predictor games designed to drive customer acquisition,
                        brand engagement and customer retention. Get in touch to discuss our white label gaming solutions."
                    />
                </Helmet>
                <div className="header" role="banner">
                    <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                        <div className="container">
                            <div className="navbar-header">
                                <button
                                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                    type="button"
                                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                                    data-toggle="collapse"
                                    data-target="#navbar-collapse-mid"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                </button>
                                <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                </Link>
                                <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                            </div>
                            <nav
                                className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'}
                                id="navbar-collapse-left"
                                aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                            >
                                {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                            </nav>
                            <nav className="collapse navbar-collapse" id="user-profile">
                                <ul className="nav navbar-nav navbar-right">
                                    <li className="user-nav-option">
                                        <div className="user">
                                            <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                    <a href="javascript:void(0);"><i className="icon-plus-circular" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    {(this.cookies.get('username')) ? 
                                      <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                          <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                            <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                          </a>
                                          <ul className="dropdown-menu">
                                                <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                <li onClick={() => Utils.logout()}>
                                                  <Link to="/login">
                                                    <i className="icon-logout"/>
                                                    LOGOUT
                                                  </Link>
                                                </li>
                                          </ul>
                                      </li>
                                      :
                                      null}
                                </ul>
                            </nav>
                        </div>
                    </header>
                </div>
                <div className="info-ribbon">
                    <div className="container">
                        <div className="h4 text-center">Contact</div>
                    </div>
                </div>
                <main className="main">
                    <div className="container">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="panel-icon">
                                    <i className="icon-terms" />
                                </div>
                                <div className="core-text">
                                    <div className="h3">For the members</div>
                                    The Accumulator Club is a new online football game with a unique set of playing criteria and points scoring system. We recommend that you familiarise yourself how to play and how points are scored.
                                    <br />
                                    <br /> Check out How to Play <a href="javascript:void(0);" title="">here</a>
                                    <br />
                                    <br /> Have a read through our blog <a href="#" title="">here</a> and hopefully it will help you make your selections - Feel free to comment and communicate!<br /><br />
                                    Tell your friends and colleagues about The Accumulator Club and invite them to play – You can setup a private league and establish who is the king or queen of football predictions!
                                    <br />
                                    <br /> If you have any questions or queries about the game, or any other aspect of the website then please get in touch by email here  –
                                    <br /> <a href={'mailto:' + Assets.supportMail}>{Assets.supportMail}</a>
                                    <br />
                                    <br />
                                    <div className="h3">For the future partners</div>
                                    The Accumulator Club is the BEST Premier League predictions game around. We have created an original concept that bridges the gap between sports betting and social gaming with an exciting challenge that can be enjoyed in private leagues by friends, colleagues, sports teams and social groups alike.
                                    <br />
                                    <br /> The Accumulator Club is fun to play and will massively boost engagement for sports websites, media/news outlets, or any brand interested in aligning with football. Therefore, we are keen to share our passion and ideas for collaboration with investors and media partners.
                                    <br />
                                    <br /> To find out more, please get in touch by email here - <a href={'mailto:' + Assets.contactMail}>{Assets.contactMail}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </section>
        )
    }
}

export class HowToPlay extends React.Component<{}, { userDropdown: boolean, mobileMenu: boolean, section: number }> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            mobileMenu: false,
            section: 0
        }
    }

    render() {
        return (
            <section className="wrapper">
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>The Accumulator Club – Premier League predictions – How to Play</title>
                    <meta 
                        name="description" 
                        content="The Accumulator Club is a free to play football game where users make predictions
                        across a number of different betting markets. Earn points for all correct selections, based on real
                        sportsbook odds and compete throughout the season in private leagues and the overall rankings."
                    />
                </Helmet>
                <div className="header" role="banner">
                    <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                        <div className="container">
                            <div className="navbar-header">
                                <button
                                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                    type="button"
                                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                                    data-toggle="collapse"
                                    data-target="#navbar-collapse-mid"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                </button>
                                <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                </Link>
                                <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                            </div>
                            <nav
                                className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'}
                                id="navbar-collapse-left"
                                aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                            >
                                {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                            </nav>
                            <nav className="collapse navbar-collapse" id="user-profile">
                                <ul className="nav navbar-nav navbar-right">
                                    <li className="user-nav-option">
                                        <div className="user">
                                            <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                    <a href="javascript:void(0);"><i className="icon-plus-circular" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    {(this.cookies.get('username')) ? 
                                      <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                          <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                            <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                          </a>
                                          <ul className="dropdown-menu">
                                                <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                <li onClick={() => Utils.logout()}>
                                                  <Link to="/login">
                                                    <i className="icon-logout"/>
                                                    LOGOUT
                                                  </Link>
                                                </li>
                                          </ul>
                                      </li>
                                      :
                                      null}
                                </ul>
                            </nav>
                        </div>
                    </header>
                </div>
                <div className="info-ribbon">
                    <div className="container">
                        <div className="h4 text-center">How To Play</div>
                    </div>
                </div>
                <main className="main">
                    <div className="container">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="panel-icon">
                                    <i className="icon-terms" />
                                </div>
                                <div className="core-text-lg">
                                    <div className="how-to-play">
                                        {this.setSections()}
                                    </div>
                                    {this.setContent()}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </section>
        )
    }

    setSections(): JSX.Element[] {
        const sections: JSX.Element[] = []
        const sectionsContent: string[] = ['Overview', 'Instructions', 'Points system', 'Private leagues']
        for (let i = 0; i < sectionsContent.length; i++) {
            sections.push(
                <span
                    key={sections.length}
                    className={(this.state.section === i) ? 'how-to-play-section how-to-play-section-colored' : 'how-to-play-section'}
                    onClick={() => this.setState({ section: i })}
                >
                    {sectionsContent[i]}
                </span>
            )
        }

        return sections
    }

    setContent(): JSX.Element {
        switch (this.state.section) {
            case 0:
                return (
                    <div className="how-to-play-content">
                        <p>“Triple Threat” is a free2play predictor format that offers an exciting new challenge to football fans
                        everywhere! The aim of the game is to score points by predicting match outcomes in the featured
                        set of fixtures, across 3 betting criteria. Points are based on the odds offered by our betting partners
                        and bonus points are awarded for landing triples, so think about your strategy! At the end of each
                        gaming round, the winner is the user with the most accumulated points!</p>
                        <br/>
                        <h3>Triple Threat game format</h3>
                        <p>The group stages have been broken down into 10 gaming rounds. Each round features 4 or 6 fixtures
                        depending on the daily tournament schedule. You will complete your predictions and entry into each
                        game round in 3 simple steps…</p>
                        <p><u>1. Make a correct score (and 1X2) triple!</u></p>
                        <p>Study the fixture list, check out team form and players stats and predict the final score of
                        any 3 matches of your choice.</p>
                        <p><u>2. Make a Goal Markets triple!</u></p>
                        <p>Predict a goal markets outcome for any 3 matches of your choice. Choose from Both Teams
                        To Score, Over/Under 2.5 goals, or a Draw, in any combination.</p>
                        <p><u>3. Make an Anytime Goalscorer triple!</u></p>
                        <p>Back any 3 players to score at any time.</p>
                    </div>
                )
            case 1:
                return (
                    <div className="how-to-play-content">
                        <h3>Correct Scores</h3>
                        <p>Users predict the final score of any 3 fixtures and this will also automatically select the predicted
                        outcome (1/X/2). Click on the circle next to one of the teams and you will see a table displaying a
                        variety of possible scores and the associated odds/points. Click a team name if you would like to
                        view their stats and qualifying record and when you´re ready, make your decision!</p>
                        <img src="instructions1.png"/>
                        <p>To reset/remove any of your predictions simply click the red (x) and predict a different fixture. Once
                        you are satisfied with your 3 predictions, click continue to go to the next step...</p>
                        <br/>
                        <p>Remember: You will receive the 1X2 odds as points if the outcome is correct and you will receive
                        bonus points according to our POINTS SYSTEM if you get the correct score as well. So how will you
                        play? Shorter odds might be safer, but land those longer odds punts and you could hit the top of the
                        table - #WHATSYOURSTRATEGY?</p>
                        <h3>Goal Markets</h3>
                        <p>Here users predict a goal markets outcome on any 3 fixtures of their choice. User can choose from
                        “Both teams to score”, “Over 2.5 goals”, “Under 2.5 goals” and “Draw”, in any combination – just
                        like you might do at the bookies.</p>
                        <img src="instructions2.png"/>
                        <p>To de-select any of your predictions you must click on it a second time, the selection will no longer
                        be highlighted and you are free to make a different selection. Once you are satisfied with your 3
                        selections click continue to go to the next step.</p>
                        <br/>
                        <h3>Anytime Goalscorers</h3>
                        <p>TThis is straight forward. Users choose 3 anytime goalscorers from any team in the featured fixtures
                        (and it’s possible to select multiple players from the same team).</p>
                        <img src="instructions3.png"/>
                        <p>To deselect a goalscorer selection, you can either click the red (x), or click the player a second time.
                        He will no longer be highlighted in green and you are free to make a different selection. Once you
                        are satisfied with your 3 selections click continue to confirm your free entry!</p>
                    </div>
                )
            case 2:
                return (
                    <div className="how-to-play-content">
                        <p><i>Please note: We use a third party data feed to display odds and the odds dictate the points that will
                        be distributed for correct selections. Odds are subject to change from time to time and your points
                        may differ from those displayed. Where possible, the odds and projected points will be finalized at
                        the time of the deadline for the round in question.</i></p>
                        <br/>
                        <h3>Correct scores</h3>
                        <p>There are two parts to the points system in step 1.</p>
                        <p>First - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection as points</p>
                        <p>Second - Correct score at full time (90mins) = Earn 1X2 odds as above + bonus according to the table
                        below;</p>
                        <p>Correct score odds 1 &#8594; 9.99 | 2 points</p>
                        <p>Correct score odds 10 &#8594; 24.99 | 3 points</p>
                        <p>Correct score odds 25+ | 5 points</p>
                        <br/>
                        <p>All 1X2 points are multiplied together to give a 1X2 total. And separately, Correct score bonus points
                        are multiplied together.</p>
                        <br/>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections.
                        Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!</p>
                        <br/>
                        <h3>Goal Markets</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                        Points from each correct selection are multiplied together to give a Goal Markets total.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3
                        selections.</p>
                        <br/>
                        <h3>Anytime Goalscorers</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                        Points from each correct selection are multiplied together to give a Goalscorers total.</p>
                        <p>A further bonus of 3 points is awarded if all three of the user´s selections score 1 goal or more.</p>
                    </div>
                )
            case 3:
                return (
                    <div className="how-to-play-content">
                        <p>Please use the Leagues page to create your own private league and challenge your friends and foes.
                        The page will display the ‘create a league’ tab by default. Enter a name for your league and click on
                        create – Easy!</p>
                        <img src="private-leagues1.png"/>
                        <p>Once the league has been created you will receive a unique code to pass on to friends and
                        colleagues. They will need to sign up for membership and enter the unique code by switching the
                        panel on the leagues page to ‘join a league’.</p>
                        <img src="private-leagues2.png"/>
                        <p>Just enter the code into the box and click CONFIRM THE CODE.</p>
                        <p>In both the overall rankings and private leagues you can check the performance history of your rivals
                        by clicking their username. You will see their predictions and points in the most recent game round
                        by default, but you can also use the dropdown box in the top right to view their previous scores.</p>
                    </div>
                )
            default:
                return (
                    <div className="how-to-play-content">
                        <p><i>Terms &amp; Conditions for Accumulator Club competition</i></p>
                        <h3>General</h3>
                        <p>1. These terms and conditions cover The Accumulator Club competition that will run
                        from 13/06/2018 to 08/07/2018</p>
                        <p>2. Accumulator Club is a free to play competition with 13 game rounds. Each round there
                        is a cash prize of 20 £ / € / $ to be won and the overall winner will win a Ps4 with Fifa 18
                        bundle.</p>
                        <p>3. The competition is open to anybody over the age of 18, residing in any country.</p>
                        <p>4. Cash prizes for the winner of each round can be awarded to anyone. But the overall prize,
                        the Ps4 can only be awarded to a resident in Europe.</p>
                        <p>5. Accumulator Club admin will endeavor to contact winners within 48 hours of a round
                        closing, or the competition closing. We will provide further instructions on how to claim.</p>
                        <p>6. If a winner does not respond within 30 days after we have made contact through their
                        registered email address, the winnings will be forfeited.</p>
                        <p>7. These terms &amp; conditions should be read and understood alongside our website terms &amp;
                        conditions.</p>
                        <br/>
                        <h3>The game</h3>
                        <p>1. Each game round has a deadline for entry and you will not score any points if you do not
                        confirm an entry before the deadline.</p>
                        <p>2. You can edit your selections at any time up to the deadline for that round.</p>
                        <p>3. After the deadline has passed for a round, you will not be able to edit your selections.</p>
                        <p>4. In the event that one of your selections does not appear, you will not receive any points.</p>
                        <p>5. We use a third party data feed to display odds and the odds dictate the points that will be
                        distributed for correct selections. Odds are subject to change from time to time and your
                        points may differ from those displayed. Where possible, the odds and projected points will
                        be finalized at the time of the deadline for the round in question.</p>
                        <p>6. Points from every round you enter will automatically be accumulated and place you on
                        overall and private rankings.</p>
                        <p>7. The winner of each round is the user who scores the most points for that round.</p>
                        <p>8. The overall winner is the user who has accumulated the most points after the final round
                        (Round 13), which will be after the quarter finals in the knockout phase.</p>
                        <p>9. In the unlikely case that two users have the same total points, ranking will be decided first
                        by total correct score points, then goalscorer points if users are still equal.</p>
                        <p>10. Accumulator Club shall not be liable for technical, hardware, software or network conditions
                        that may limit or prohibit your ability to enter or participate in the Competition.</p>
                        <br/>
                        <p>If you do not meet the eligibility requirements for entering the competition, or for claiming a prize,
                        your entries will be deemed void and you will be ineligible for prizes. If you are in fact infringing on
                        any of these terms and conditions, or those of the website, your account may be deactivated.</p>
                        <br/>
                        <p>By entering the competition you confirm that you have read and understood these terms and
                        conditions and agree to their content and ruling.</p>
                    </div>
                )
        }
    }
}

export class Terms extends React.Component<{}, { userDropdown: boolean, mobileMenu: boolean }> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            mobileMenu: false
        }
    }

    render() {
        return (
            <section className="wrapper">
                <div className="header" role="banner">
                    <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                        <div className="container">
                            <div className="navbar-header">
                                <button
                                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                    type="button"
                                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                                    data-toggle="collapse"
                                    data-target="#navbar-collapse-mid"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                </button>
                                <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                </Link>
                                <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                            </div>
                            <nav
                                className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'}
                                id="navbar-collapse-left"
                                aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                            >
                                {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                            </nav>
                            <nav className="collapse navbar-collapse" id="user-profile">
                                <ul className="nav navbar-nav navbar-right">
                                    <li className="user-nav-option">
                                        <div className="user">
                                            <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                    <a href="javascript:void(0);"><i className="icon-plus-circular" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    {(this.cookies.get('username')) ? 
                                      <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                          <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                            <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                          </a>
                                          <ul className="dropdown-menu">
                                                <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                <li onClick={() => Utils.logout()}>
                                                  <Link to="/login">
                                                    <i className="icon-logout"/>
                                                    LOGOUT
                                                  </Link>
                                                </li>
                                          </ul>
                                      </li>
                                      :
                                      null}
                                </ul>
                            </nav>
                        </div>
                    </header>
                </div>
                <div className="info-ribbon">
                    <div className="container">
                        <div className="h4 text-center">TERMS AND CONDITIONS</div>
                    </div>
                </div>
                <main className="main">
                    <div className="container">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="panel-icon">
                                    <i className="icon-terms" />
                                </div>
                                <div className="core-text">
                                    <div className="h3">Introduction</div>
                                    <a href="https://www.accumulatorclub.com" target="_blank">www.accumulatorclub.com</a> is a service 
                                    operated by Fair Play Gaming Ltd and for the purpose of these terms of service will be described as 
                                    “The Accumulator Club”, “website”, “we” or “us”. "Game" means a game played on the The Accumulator Club 
                                    plaform, “Match Day” means a calendar day (Eg. Saturday or Sunday) where fixtures associated with 
                                    the game are played out in reality. “You” and “User/s” means you, visitors to the website and 
                                    participants in The Accumulator Club games, also bound by these Terms of service. “Player/s” means 
                                    the real athletes named and featured in the games.
                                    <br/>
                                    <br/>
                                    The Accumulator Club is a social gaming platform that offers free to play sports betting predictor 
                                    games. Users can create a profile, make entries into the games, setup private leagues and invite 
                                    friends and colleagues to participate, track their results and those of other users.
                                    <br/>
                                    <br/>
                                    Please read these Terms of service carefully. They form a legal agreement between you and Fair Play 
                                    Gaming Ltd. Along with your understanding and acceptance of the privacy policy, these terms of service 
                                    govern your membership of the website and you agree to their content.
                                    <br/>
                                    <br/>
                                    By signing up to participate in The Accumulator Club games you are confirming that you have read,
                                    understood and accepted these terms of service and agree to be bound by them. You also confirm
                                    that you are over 18 years of age.
                                    <br/>
                                    <br/>
                                    We may modify or update these terms of service from time to time. If you are not happy with any
                                    modification, you must stop using the Website. If you keep using the Website, this will indicate your
                                    acceptance of any updates. We may notify key changes to you, but you should review these terms of
                                    service from time to time to ensure you are aware of any changes.
                                    <br/>
                                    <br/>
                                    <div className="h3">Conditions of Participation</div>
                                    The Accumulator Club is open to both UK and non-UK residents, but you must be at least 18 years of
                                    age to use the website, participate in the games and claim prizes. If we have reason to believe you
                                    are under the age of 18, we will suspend your account immediately and request proof of age. Failure
                                    to provide such information within a reasonable period of time will result in account termination.
                                    <br/>
                                    <br/>
                                    All players must adhere to these Terms of service and follow the onscreen instructions on the
                                    Website. Users will be requested to enter their name, email address, a password and a username. A
                                    welcome email, including a link to verify your email address will be received after completing the
                                    sign up successfully. You will need to verify your email address before you can participate in any
                                    Games.
                                    <br/>
                                    <br/>
                                    The Games are free to play, but in the future The Accumulator Club may offer real money games.
                                    When such games are offered on the website, all users who wish to participate will be ID checked
                                    and required to accept an updated version of these terms and conditions before depositing funds for
                                    use on the website.
                                    <br/>
                                    <br/>
                                    Any one person (user) is only permitted to sign up for one membership at The Accumulator Club. All
                                    accounts must be registered with a valid personal email address to which you have sole access. Any
                                    use of multiple accounts is deemed as a breach of these Terms of service. If we have reason to
                                    suspect a breach has been made, an email will be sent to issue a warning. Any further abuse of this
                                    condition may result in the termination of all connected accounts.
                                    <br/>
                                    <br/>
                                    The Accumulator Club reserves the right to close accounts if any user is found to be using proxy IPs
                                    (Internet Protocol addresses) in order to attempt to hide the use of multiple memberships.
                                    <br/>
                                    <br/>
                                    <div className="h3">Copyrighted material, rights of use and intellectual property rights</div>
                                    Your use of any information or materials on The Accumulator Club is entirely at your own risk, for
                                    which we shall not be liable.
                                    <br/>
                                    <br/>
                                    This website and application contain material which is owned by or licensed to The Accumulator
                                    Club. This material includes, but is not limited to, trademarks, design, layout, appearance,
                                    programming code, databases and the concept or format of the games, how they are played and the
                                    point scoring systems associated. Any development of software or functionality that copies or
                                    mimics any part of the site and those aspects detailed above is strictly prohibited and any
                                    unauthorised reproduction or attempt to do so may give rise to a claim for damages and/or be a
                                    criminal offence.
                                    <br/>
                                    <br/>
                                    All imagery and trademarks that have been reproduced on this website which are not the property
                                    of, or licensed to, The Accumulator Club are acknowledged on the website.
                                    <br/>
                                    <br/>
                                    All third party trade names and trademarks are the property of their respective owners and we make
                                    no warranty or representation in relation to them.
                                    <br/>
                                    <br/>
                                    Subject to these terms and conditions and your compliance with them, we grant you a non-
                                    exclusive, non-transferable, personal, limited license to access and use the Website and the content
                                    solely for your private, non-commercial, personal use only.
                                    <br/>
                                    <br/>
                                    <div className="h3">Gameplay</div>
                                    The How to Play page provides a detailed explanation of how to navigate the site, access the games
                                    and enter your predictions and selections. A link to the How to Play page is available in the top menu
                                    and the footer of every page on the website. Players should read this page carefully before playing
                                    any game on The Accumulator Club. The How to Play page is to be used as the first point of
                                    reference if a player finds an issue with any aspect of the website or a game on the website.
                                    <br/>
                                    <br/>
                                    The Accumulator Club has purchased a data provision package from Goalserve, Inc. And utilises an
                                    odds feed API from multiple third parties (can change from time to time). The data received will
                                    dictate the points distributed, according to the points system detailed on the How to Play page. The
                                    How to Play page is to be used as the first point of reference if a player finds an issue with the
                                    distribution of points. The points distributed at the end of any given match day are subject to
                                    revisions by the odds or stats provider. In the event this occurs, the points on The Accumulator Club
                                    will be updated accordingly.
                                    <br/>
                                    <br/>
                                    Many of our games will run for the entirety of a competition (Eg. Start to finish of a domestic sports
                                    season or international tournament). Users are able to begin playing these games at any stage
                                    during the competition and will automatically be positioned in the overall rankings as they
                                    accumulate points.
                                    <br/>
                                    <br/>
                                    Each gaming round has a deadline for entries and it will not be possible to enter a gaming round
                                    after the deadline has passed.
                                    <br/>
                                    <br/>
                                    The Accumulator Club reserves the right to limit access to the site during periods of necessary
                                    updates to player profiles, points, rankings, games available etc.
                                    <br/>
                                    <br/>
                                    <div className="h3">Code of Conduct</div>
                                    The Accumulator Club, in its sole discretion reserves the right to suspend and delete teams or entire
                                    leagues that contain team names or league names which are deemed to be inappropriate or
                                    offensive. Depending on the seriousness of the situation, a user&#39;s account may be permanently
                                    removed.
                                    <br/>
                                    <br/>
                                    In due course, The Accumulator Club will provide the facility to leave comments on the blog, or
                                    contribute to a forum/message board. To participate and contribute in these areas of the website
                                    you will be required to sign up for membership. These Terms and Conditions govern that
                                    membership and in accepting these Terms and Conditions you also agree to use any blog, forum or
                                    message board in accordance with the following rules;
                                    <ul>
                                        <li>No Defamation, stalking, bullying, abuse, harassment, impersonation or use of threatening
                                        or intimidating behaviour towards other Accumulator Club members, or any other third
                                        party.</li>
                                        <li>Do not publish or upload any material that is unlawful, harassing, threatening, defamatory,
                                        obscene, offensive, abusive, hateful, inflammatory, profane, racially, sexually or religiously
                                        offensive or otherwise objectionable or unlawful.</li>
                                        <li>No spamming, soliciting services or advertising to other Accumulator Club members, or any
                                        other third party.</li>
                                        <li>Do not transmit material that contains viruses or any other malicious code designed to
                                        interrupt, delete, or deny the functionality of any software or hardware.</li>
                                        <li>Do not use automated software including robots, spiders and scrapers to extract Game
                                        content without written consent from The Accumulator Club.</li>
                                        <li>Do not submit or share material that may violate, plagiarise, or infringe – the copyright,
                                        trademark/s, trade secrets, privacy, publicity, personal or proprietary rights of The
                                        Accumulator Club, or any third party.</li>
                                    </ul>
                                    <br/>
                                    If you fail to abide by these Rules when contributing to and using The Accumulator Club website,
                                    your contribution may well be edited or removed without warning. If further indiscretions are made,
                                    an email will be sent issuing a warning that continuing to break the rules may result in the
                                    termination of your membership.
                                    <br/>
                                    <br/>
                                    The Accumulator Club reserves the right to delete any contribution, or take action against any
                                    member, at any time, for any reason.
                                    <br/>
                                    <br/>
                                    <div className="h3">In-game player status and information</div>
                                    The football players and other athletes that are named and used in the games are those provided by
                                    our data and odds providers. The official squad selections, player info and numbers are accurate to
                                    the best of our knowledge. The data providers have used best research practice and common
                                    perception to determine each player’s position, which may not necessarily reflect the position in
                                    reality, or that of any other third party. At the discretion of The Accumulator Club, players and
                                    athletes may be added, modified or removed from the game.
                                    <br/>
                                    <br/>
                                    Within the website and the user interface of the games, team and player information and statistics
                                    will be available to check in order to help make informed decisions on playing the game. This
                                    information is drawn from the data provided and is not researched or updated by The Accumulator
                                    Club – We cannot edit this information and we cannot accept any responsibility for the affect it has
                                    on your entries in the games. Although we know the information to be very accurate, it should be
                                    treated as a guideline and there is no guarantee of its accuracy at any given time.
                                    <br/>
                                    <br/>
                                    <div className="h3">Registration, Account Password and Security</div>
                                    Many areas of the Website require registration for access. If you choose to provide information to
                                    The Accumulator Club, you hereby agree to provide accurate and complete information. By creating
                                    a user account, you accept responsibility for all activities that occur under your account including
                                    maintaining the confidentiality of your password and restricting access to your computer and mobile
                                    devices so that others may not access any protected areas. You agree to indemnify The Accumulator
                                    Club for any improper or illegal use of your account.
                                    <br/>
                                    <br/>
                                    <div className="h3">Limitation on Liability</div>
                                    The information on this website and its associated news and blogs is subject to change at any time.
                                    <br/>
                                    <br/>
                                    Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness,
                                    performance, or suitability of the information, tools or games found or offered on this website for
                                    any particular purpose. You acknowledge that such information, tools and games may contain
                                    inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors.
                                    <br/>
                                    <br/>
                                    The Accumulator Club assumes no liability for loss or damage resulting from any use of or reliance
                                    upon the games or the content found on this website. In no event will The Accumulator Club, or any
                                    of its affiliates be liable for any lost profits, lost savings, lost data, business interruption, or other
                                    consequential damages or claims arising from the use of The Accumulator Club website or
                                    applications.
                                    <br/>
                                    <br/>
                                    The Accumulator Club may occasionally provide links to other websites. These links are provided for
                                    your convenience and to provide further information deemed to be of interest. They do not signify
                                    that we endorse the linked website/s, nor do we have responsibility for the content on the linked
                                    website/s.
                                    <br/>
                                    <br/>
                                    The Accumulator Club does not offer gambling facilities at this time, although we may link to third
                                    party sites that do. Use of any third party sites is at your own risk and The Accumulator Club will not
                                    be liable for any lost profits, lost savings, lost data, business interruption, or other consequential
                                    damages or claims arising from the use of linked sites.
                                    <br/>
                                    <br/>
                                    <div className="h3">Prizes</div>
                                    The Accumulator Club is free to play, but cash prizes will be awarded to users in certain games.
                                    Generally these prizes are for the overall rankings winner (most points) in each individual gaming
                                    round and also the winner in the overall rankings at the end of a competition (most overall points in
                                    that competition).
                                    <br/>
                                    <br/>
                                    The terms and conditions outlined below cover the ruling around the rewarding and payment of
                                    cash prizes only.
                                    <br/>
                                    <br/>
                                    The winner of any gaming round or full competition where cash prizes are linked, will need to
                                    contact us by email from the address registered on their account, to the following address;
                                    <a href="mailto:admin@accumulatorclub.com"> admin@accumulatorclub.com </a>
                                    in order to make a claim. Cash prizes will be sent by Paypal only and
                                    we will not ask for any personal account information at any time. Cash prizes will only be paid in
                                    Euros (€), Pound sterling (£), or US dollars ($).
                                    <br/>
                                    <br/>
                                    We may also offer other forms of prize from time to time in the competitions we operate on the
                                    website. Any prize that is offered that is not cash will most likely carry additional terms and
                                    conditions, exclusions and limitations. These will be made available for review and a link to view
                                    them will be clearly indicated on the website and any advertisement.
                                    <br/>
                                    <br/>
                                    Users should read the terms and conditions of any competition where we offer prizes carefully. Your
                                    entry and participation into any game where prizes can be won is taken as expressed agreement of
                                    the terms and conditions of that game. Therefore, in agreeing to these terms and conditions you
                                    assume responsibility to read, understand and accept any additional terms and conditions of games
                                    with prizes.
                                    <br/>
                                    <br/>
                                    These Terms and Conditions will be interpreted in accordance with English law and the users agree
                                    that all claims arising from their participation in the Game will be under the exclusive jurisdiction of
                                    the Courts of England and Wales.
                                    <br/>
                                    <br/>
                                    All questions, comments or enquiries should be emailed directly to us at;
                                    <a href="mailto:support@accumulatorclub.com"> support@accumulatorclub.com </a>and we will try to respond within 48 hours.
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </section>
        )
    }
}

export class Privacy extends React.Component<{}, { userDropdown: boolean, mobileMenu: boolean }> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            mobileMenu: false
        }
    }
    
    render() {
        return (
            <section className="wrapper">
                <div className="header" role="banner">
                    <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                        <div className="container">
                            <div className="navbar-header">
                                <button
                                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                    type="button"
                                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                                    data-toggle="collapse"
                                    data-target="#navbar-collapse-mid"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                </button>
                                <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                </Link>
                                <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                            </div>
                            <nav
                                className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'}
                                id="navbar-collapse-left"
                                aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                            >
                                {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                            </nav>
                            <nav className="collapse navbar-collapse" id="user-profile">
                                <ul className="nav navbar-nav navbar-right">
                                    <li className="user-nav-option">
                                        <div className="user">
                                            <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                    <a href="javascript:void(0);"><i className="icon-plus-circular" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    {(this.cookies.get('username')) ? 
                                      <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                          <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                            <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                          </a>
                                          <ul className="dropdown-menu">
                                                <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                <li onClick={() => Utils.logout()}>
                                                  <Link to="/login">
                                                    <i className="icon-logout"/>
                                                    LOGOUT
                                                  </Link>
                                                </li>
                                          </ul>
                                      </li>
                                      :
                                      null}
                                </ul>
                            </nav>
                        </div>
                    </header>
                </div>
                <div className="info-ribbon">
                    <div className="container">
                        <div className="h4 text-center">PRIVACY POLICY</div>
                    </div>
                </div>
                <main className="main">
                    <div className="container">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="panel-icon">
                                    <i className="icon-privacy" />
                                </div>
                                <div className="core-text">
                                    This privacy policy (The “policy”)is for The Accumulator Club website (The “website”) located at
                                    www.accumulatorclub.com. The policy describes the way in which The Accumulator Club collects,
                                    processes, stores, uses and protects the personal data and information you provide.
                                    <br />
                                    <br /> 
                                    Please read the policy carefully. Along with our terms of service, it governs your use of the website.
                                    By accepting this Privacy Policy you agree that you understand and accept the use of your personal
                                    information as set out in the policy. If you do not agree with the terms of this Privacy Policy please
                                    do not use the Website or otherwise provide us with your personal information.
                                    <br />
                                    <br />
                                    <div className="h3">Who we are</div>
                                    For the purposes hereof, “The policy” means this privacy policy, “The Accumulator Club”, “website”,
                                    “website owners”, “we” or “us” mean Fair Play Gaming Ltd, a company incorporated in the United
                                    Kingdom (company number 10636954) with its registered office at Home Mead, Camel Street,
                                    Marston Magna, Somerset, BA22 8DB.
                                    <br />
                                    <br />
                                    We are dedicated to safeguarding user privacy and ensure that the necessary steps are taken to
                                    protect the privacy of users throughout their visiting and gaming experience. We control the ways
                                    your Personal Data is collected and the purposes for which your Personal Data is used by The
                                    Accumulator Club, under our responsibilities as a “data controller”. We take the necessary actions
                                    and have the appropriate measures in place to adhere to applicable European data protection
                                    legislation.
                                    <br/>
                                    <br/>
                                    “You” or “User/s” mean persons using the internet or specifically persons visiting and participating in
                                    activities on The Accumulator Club website.
                                    <br/>
                                    <br/>
                                    <div className="h3">Contact us</div>
                                    If you have any concerns, or would like more detail about how we process your Personal Data, you
                                    can contact us using <a href="mailto:support@accumulatorclub.com">support@accumulatorclub.com</a>.
                                    <br/>
                                    <br/>
                                    <div className="h3">Information Collected</div>
                                    The information and data about you which we may collect, use and process includes the following:
                                    <ul>
                                        <li>Information that you provide to us by filling in forms on the Website or any other
                                        information you submit to us via the Website or email</li>
                                        <li>Records of correspondence, whether via the Website, forms or emails</li>
                                        <li>Your responses to surveys or customer research that we carry out</li>
                                        <li>Data from your IP address when entering the website, such as location data</li>
                                    </ul>
                                    <br/>
                                    <div className="h3">Protecting Your Personal Data</div>
                                    The law states that we can only process your Personal Data when there is a genuine reason to do so
                                    and it must be one of the following:
                                    <ul>
                                        <li>To fulfil any contract that we have with you</li>
                                        <li>We have a legal obligation</li>
                                        <li>Where you have consented to the processing</li>
                                        <li>When it is in our legitimate interest</li>
                                        <li>When it is in the public interest</li>
                                        <li>When it is in your vital interests</li>
                                    </ul>
                                    <br/>
                                    <div className="h3">Use of data and information</div>
                                    Users contacting this website and/or its owners do so at their own discretion and provide any such
                                    personal details requested at their own risk. Your personal information is kept private and stored
                                    securely until a time it is no longer required or has no use.
                                    <br/>
                                    <br/>
                                    The information that we store relating to you will mainly be used for fulfilling our obligation to you
                                    as part of our service. This primarily relates to, although is not limited to:
                                    <ul>
                                        <li>Assisting you with any questions or queries you have submitted</li>
                                    </ul>
                                    <br/>
                                    We also deem the following to be within our legitimate interest, or your vital interests:
                                    <ul>
                                        <li>Contacting you regarding a breach of our Terms of service</li>
                                        <li>Notifying you of important deadlines and information for the games you have participated in</li>
                                        <li>To make you aware of other relevant games as we launch them</li>
                                    </ul>
                                    <br/>
                                    If we use legitimate interests or your vital interests as a reason to process your Personal Data (or
                                    send you emails) we will also provide you with a method to manage what type of communications
                                    you receive. However, compelling grounds for processing such information may over-ride your right
                                    to object.
                                    <br/>
                                    <br/>
                                    <div className="h3">How long we keep your Personal Data</div>
                                    Whenever your data is kept by The Accumulator Club we will ensure that it is appropriately
                                    protected and only used for acceptable purposes.
                                    <br/>
                                    <br/>
                                    We will keep your data for the period that you hold an account at The Accumulator Club.
                                    <br/>
                                    <br/>
                                    If you would like us to remove your account and delete your data, you will need to contact us at the
                                    email address provided under “Contact us”
                                    <br/>
                                    <br/>
                                    <div className="h3">Cookies policy</div>
                                    We use cookies to improve the user experience while visiting the website. Where applicable this
                                    website uses a static message to inform visitors of the use of cookies on their computer/device the
                                    first time they visit the site. The message will contain a link to this page where visitors can learn
                                    more about our cookie policy. Continued use of the website or removal of the message is confirmed
                                    acceptance of this policy.
                                    <br/>
                                    <br/>
                                    Cookies are small files saved to the user’s computer hard drive that track, save and store information
                                    about the user&#39;s interactions and usage of a website. This allows the website, through its server to
                                    provide the users with a tailored experience when visiting the website and returning to the website
                                    in the future.
                                    <br/>
                                    <br/>
                                    This website uses tracking software to monitor site traffic and better understand how visitors are
                                    using it. This software is provided by Google Analytics which uses cookies to track visitor usage. The
                                    software will save a cookie to your computer’s hard drive in order to track and monitor your
                                    engagement and usage of the website. However, the software will not store, save or collect personal
                                    information. You can read Google&#39;s privacy policy here for more information – <a href="https://privacy.google.com" target="_blank">www.google.com/privacy</a>
                                    <br/>
                                    <br/>
                                    Cookies are also very commonly used in online advertising as they can be used to build a profile of
                                    the sites you are visiting. Advertisers can then direct more targeted advertisements, of more
                                    perceived interest to you while you surf the internet. This website provides advertising space and
                                    therefore, cookies may be stored on your computer’s hard drive by external vendors when this
                                    website uses referral programs, sponsored links or adverts. Such cookies are used for conversion and
                                    referral tracking and typically expire after 30 days, though some may take longer. However, no
                                    personal information is ever stored, saved or collected.
                                    <br/>
                                    <br/>
                                    Although cookies are used across almost every site on the internet, some users do not like the idea
                                    of this information being stored on their computer. Through your browser settings, it is possible to
                                    delete existing cookies and block them from being used in the future. However, this will mean you
                                    could lose some functionality on The Accumulator Club and other websites.
                                    <br/>
                                    <br/>
                                    This website – <a href="https://www.aboutcookies.org" target="_blank" style={{ color: '#000', fontWeight: 'bold' }}>www.aboutcookies.org</a> – will help you explore your options when it comes to
                                    removing and turning off cookies in your browser.
                                    <br/>
                                    <br/>
                                    <div className="h3">External links</div>
                                    You may find links to third party websites on this website. These websites should have their own
                                    privacy policies, which you should check - We do not accept any responsibility or liability for their
                                    policies.
                                    <br/>
                                    <br/>
                                    The Accumulator Club cannot guarantee or verify the contents of any external linked website. Users
                                    should therefore note they click on external links at their own risk and this website and its owners
                                    cannot be held liable for any damages or implications caused by visiting the external links
                                    mentioned.
                                    <br/>
                                    <br/>
                                    <div className="h3">Adverts and Sponsored Links</div>
                                    This website may contain sponsored links and adverts. These are delivered through our advertising
                                    partners who have their own detailed privacy policies relating directly to the adverts they deliver.
                                    <br/>
                                    <br/>
                                    Clicking on any such adverts will send you to the advertiser’s website through a referral program
                                    which may use cookies and will track the number of referrals sent from this website. This may
                                    include the use of cookies that will be saved on your computer’s hard drive. Users should therefore
                                    note they click on adverts and sponsored links at their own risk and this website and it&#39;s owners
                                    cannot be held liable for any damages or implications caused by visiting any adverts and sponsored
                                    links mentioned.
                                    <br/>
                                    <br/>
                                    <div className="h3">Social Media Platforms</div>
                                    Communication, engagement and actions taken through external social media platforms that this
                                    website and it&#39;s owners participate on are compliant with the terms and conditions and privacy
                                    policies held with each social media platform respectively.
                                    <br/>
                                    <br/>
                                    Users are advised to use social media platforms wisely and communicate / engage upon them with
                                    due care and caution in regard to their own privacy and personal details. This website nor it&#39;s owners
                                    will ever ask for personal or sensitive information through social media platforms and encourage
                                    users wishing to discuss sensitive details to contact them through primary communication channels
                                    such as telephone or email.
                                    <br/>
                                    <br/>
                                    This website may use social sharing buttons which help share web content directly from web pages
                                    to the social media platform in question. Users are advised before using such social sharing buttons
                                    that they do so at their own discretion and note that the social media platform may track and save
                                    your request to share a web page respectively through your social media platform account.
                                    <br/>
                                    <br/>
                                    <div className="h3">Disclosing your information</div>
                                    We may only disclose your personal information to third parties:
                                    <ul>
                                        <li>If we sell any or all of our business and/or our assets to a third party</li>
                                        <li>If we are legally required to disclose your information</li>
                                        <li>To assist with fraud protection and anti-money laundering initiatives</li>
                                    </ul>
                                    <br/>
                                    <div className="h3">Contact Us</div>
                                    By using www.accumulatorclub.com you consent to our privacy policy.
                                    If you have any questions or queries regarding this privacy policy, please do not hesitate to contact:
                                    <br/>
                                    <a href="mailto:support@accumulatorclub.com">support@accumulatorclub.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </section>
        )
    }
}

withCookies(Contact, HowToPlay, Terms, Privacy)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Footer.tsx